/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initReadMoreButtons() {
    const paragraphs = document.querySelectorAll('.rich-text__read_more');
    const buttons = document.querySelectorAll('.button_read_more');

    if (!paragraphs.length || !buttons.length) return;

    paragraphs.forEach((paragraph, index) => {
      const button = buttons[index];
      if (!button) return;

      const textSpan = button.querySelector('.text_read_more');
      const icon = button.querySelector('.icon_read_more');
      const maxHeight = parseFloat(getComputedStyle(paragraph).maxHeight);

      if (paragraph.scrollHeight > maxHeight) {
        button.classList.add('show');
        paragraph.classList.add('collapsed');
      }

      button.addEventListener('click', function () {
        paragraph.classList.toggle('expanded');
        icon.classList.toggle('rotated');

        textSpan.textContent = paragraph.classList.contains('expanded') 
          ? 'Leer menos' 
          : 'Sigue leyendo';
      });
    });
  }

  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', initReadMoreButtons);

  // Re-initialize when Shopify section is reloaded
  document.addEventListener('shopify:section:load', initReadMoreButtons);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



function toggleTextTruncation(event, selector) {
  event.preventDefault();
  const text = document.querySelector(selector);
  if (!text) return;
  
  if (text.classList.contains('truncate-content')) {
    text.classList.remove('truncate-content');
  } else {
    text.classList.add('truncate-content');
  }
  const button = event.target;
  button.textContent = text.classList.contains('truncate-content') ? button.getAttribute('data-view-more') : button.getAttribute('data-view-less');
}